import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

export default function DenseTable(props) {
  const { loadbalancer } = props;

  const [copied, setCopied] = React.useState(false);

  const [copyanchorEl, setCopyanchorEl] = React.useState(null);

  const handlecopyClick = (event) => {
    setCopyanchorEl(event.currentTarget);
  };

  const handlecopyClose = () => {
    setCopyanchorEl(null);
  };

  const copyopen = Boolean(copyanchorEl);
  const copyid = copyopen ? "simple-popover" : undefined;

  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead style={{ backgroundColor: "#06396c" }}>
          <TableRow>
            <TableCell style={{ color: "#ffffff" }} align="center">
              name
            </TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">
              Application
            </TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">
              Loadbalancer
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loadbalancer.map((row) => (
            <TableRow key={row.name}>
              <TableCell align="center" component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="center" component="th" scope="row">
                Kubernetes
              </TableCell>
              <TableCell align="center">
                {row.lab}
                <CopyToClipboard text={row.lab} onCopy={() => setCopied(true)}>
                  <IconButton
                    aria-label="Filter"
                    color="primary"
                    onClick={handlecopyClick}
                  >
                    <FileCopyOutlinedIcon />
                  </IconButton>
                </CopyToClipboard>
                <Popover
                  id={copyid}
                  open={copyopen}
                  anchorEl={copyanchorEl}
                  onClose={handlecopyClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <Typography style={{ color: "forestgreen" }}>
                    Copied!.
                  </Typography>
                </Popover>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
